import { render, staticRenderFns } from "./UploadArticle.vue?vue&type=template&id=3ba729c5&scoped=true"
import script from "./UploadArticle.vue?vue&type=script&lang=js"
export * from "./UploadArticle.vue?vue&type=script&lang=js"
import style0 from "./UploadArticle.vue?vue&type=style&index=0&id=3ba729c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba729c5",
  null
  
)

export default component.exports